module.exports = __webpack_public_path__ + "a911a6d937e764b2dab5fb8babe0f362.png";